import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.009 2.25H3a.75.75 0 0 0-.75.75v18c0 .414.336.75.75.75h18a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75zm.741 1.5v16.5h16.5V3.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6 3h3v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zM10.5 3h3v14a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zM15 3h3v8a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1z"
    }, null, -1)
  ])))
}
export default { render: render }